module.exports = __webpack_public_path__ + "img/atatürk-banner-1.5a6936e3.jpeg";